<template>
<div class="main">
    <div class="sj-cpzx">
       公司地址 <span class="en-title">Company Address</span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm">
        <div class="comp-info">
            <span class="bt-comp-li"><span style="font-weight:600">公司名称：</span><i class="el-icon-discount"></i>&nbsp;山杰医疗科技（郑州）有限公司</span>
            <br><br>
            <span class="bt-comp-li"><span style="font-weight:600">地址：</span><i class="el-icon-location-outline"></i>&nbsp;河南省郑州市中牟新区官渡生物医药产业园区碣石路3号</span>
            <br><br>
            <span class="bt-comp-li"><span style="font-weight:600">联系电话：</span><i class="el-icon-phone-outline"></i>&nbsp;0371-5652 8599</span>
            <br><br>
            <span class="bt-comp-li"><span style="font-weight:600">邮箱：</span><i class="el-icon-message"></i>&nbsp;shanjieyl@163.com</span>
            <br><br>
            <!-- <span class="bt-comp-li"><span style="font-weight:600">QQ：</span><i class="el-icon-chat-line-round"></i>&nbsp;1976634441</span> -->
        </div>
        <baidu-map class="map" :center="marker" :zoom="zoom" @ready="handler">
            <!-- 标记 点 -->
            <bm-marker :position="marker" @click="infoWindow.show = !infoWindow.show"></bm-marker>
            <!-- <bm-info-window :position="marker" title="详细信息" :show="infoWindow.show" @close="infoWindow.show = false">
              <p style="font-size:14px" v-text="infoWindow.contents.name"></p>
              <p style="font-size:14px" v-text="infoWindow.contents.address"></p>
              <p style="font-size:14px" v-text="infoWindow.contents.phone"></p>
            </bm-info-window> -->
        </baidu-map>
    </div>
    <div class="sj-cpzx" style="margin-top:30px">
       在线咨询 <span class="en-title">Online Consulting</span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm">
      <div class="online-bg"><el-image :src="leaveImg" style="height: 452px"></el-image></div>
      <div class="online-form">
        <el-form label-position="left" label-width="80px" :model="onlineMsg" :rules="rules" ref="onlineMsg">
          <el-form-item label="姓名" prop="name">
            <el-input v-model.trim="onlineMsg.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model.trim="onlineMsg.phone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model.trim="onlineMsg.email" placeholder="请输入您的邮箱"></el-input>
          </el-form-item>
          <el-form-item label="咨询内容" prop="content">
            <el-input v-model.trim="onlineMsg.content" type="textarea" style="font-size: 16px"
            :autosize="{ minRows: 8}" placeholder="请输入您的咨询内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('onlineMsg')">提交</el-button>
            <el-button @click="resetForm('onlineMsg')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="sj-cpzx">
       人才招聘 <span class="en-title">Talent Recruitment</span>
       <span class="detail-title" style="float: right; margin-right: 20px;">简历投递邮箱：
       <font class="detail-main">SJYLHR76@163.COM</font></span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm" style="margin-bottom: 80px;">
        <!-- 职位列表 -->
        <el-collapse value="1" accordion>
          <el-collapse-item name="1">
            <template slot="title">
              <h2 class="job-title">医疗器械销售代表</h2>&ensp;
              &ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-office-building"></i>&ensp;河南·郑州·中牟新区</span>
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-coin"></i>&ensp;4k-9k</span>
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-monitor"></i>&ensp;5年以上医疗器械销售经验</span>
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-user"></i>&ensp;人数：若干</span>
            </template>
            <div class="job-description">
                <h3>岗位职责：</h3>
                <ul style="margin: 1rem 0; padding-left: 2rem; color: #4d4d4f; line-height: 28px;">
                    <li>客户拓展与维护<br>负责指定区域内医疗机构客户的开发与拓展，建立并维护长期稳定的合作关系，定期回访客户，了解其使用感受和新需求，提升客户满意度与忠诚度。</li>
                    <li>产品推广与销售<br>全面了解公司各类产品的性能、特点、优势及临床应用，向客户进行专业、精准的产品演示与讲解，针对不同客户需求提供合适的产品解决方案。<br>执行公司销售策略，完成个人及团队的销售任务指标，制定详细的销售计划，并根据市场动态及时调整销售策略，确保销售目标的达成。</li>
                    <li>市场信息收集<br>及时反馈客户对产品的意见和建议，协助公司优化产品性能和服务质量，提升公司产品的市场竞争力。</li>
                    <li>销售活动执行<br>负责销售合同的谈判、起草、签订及执行，确保合同条款清晰、准确，保障公司和客户双方的合法权益，及时跟进合同款项回收，确保资金安全。</li>
                </ul>
                <h3>任职要求：</h3>
                <ul style="margin: 1rem 0; padding-left: 2rem; color: #4d4d4f; line-height: 28px;">
                    <li>大专及以上学历，不限专业，条件优秀者薪资可面谈。</li>
                    <li>具有5年医疗器械销售经验，熟悉医疗器械销售流程，有医院、经销商等客户资源者优先；应届毕业生如有丰富的销售实习经验或优秀的销售潜力，也可考虑。</li>
                    <li>了解医疗器械相关法规政策，熟悉常见医疗器械产品（如康复类设备、高值耗材等）的基本原理和操作方法。</li>
                    <li>熟练使用办公软件（如Word、Excel、PowerPoint），具备一定的数据分析能力，能够运用销售数据制定有效的销售策略。</li>
                    <li>具备出色的沟通能力和人际交往能力，能够与不同层次的客户进行有效沟通，建立良好的合作关系。</li>
                    <li>具备良好的团队协作精神，能够与团队成员紧密合作，共同完成销售任务。同时，具备独立工作能力，能够自主制定工作计划并有效执行。</li>
                </ul>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <h2 class="job-title">普工</h2>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
              &ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-office-building"></i>&ensp;河南·郑州·中牟新区</span>
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-coin"></i>&ensp;3k-4k</span>
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-monitor"></i>&ensp;1年以上硬件产品组装经验</span>
              &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<span class="job-det"><i class="el-icon-user"></i>&ensp;人数：若干</span>
            </template>
            <div class="job-description">
                <h3>岗位职责：</h3>
                <ul style="margin: 1rem 0; padding-left: 2rem; color: #4d4d4f; line-height: 28px;">
                    <li>按照生产计划和作业指导书，完成产品的组装、调试、测试和包装等工作，确保按时按量完成生产任务‌。</li>
                    <li>严格遵守工艺文件和图纸的要求，对产品进行合理加工和生产，保证产品质量。并对生产过程进行监督和自检，及时发现并报告质量异常情况。</li>
                    <li>准确填写生产文件记录，确保生产数据的准确性和及时性‌。</li>
                    <li>严格遵守公司规章制度和安全生产管理制度，保持工作区域的整洁，确保安全生产和文明生产‌。</li>
                    <li>针对使用的设备按规定要求进行保养‌。</li>
                    <li>不断学习和提升生产技能和专业知识，提高工作效率和质量‌。</li>
                </ul>
                <h3>任职要求：</h3>
                <ul style="margin: 1rem 0; padding-left: 2rem; color: #4d4d4f; line-height: 28px;">
                    <li>高中及以上学历，专业不限。</li>
                    <li>1年及以上硬件产品组装经验，具备医疗器械或制造业工作经验者优先。</li>
                    <li>具体一定的动手能力，能够服从领导安排。</li>
                    <li>工作认真负责且具有良好的团队协作能力。</li>
                </ul>
            </div>
          </el-collapse-item>
        </el-collapse>
    </div>
</div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      marker: {
        lng: 114.092861,
        lat: 34.772835
      },
      zoom: 20,
      infoWindow: {
        show: false
      },
      leaveImg: require('../assets/online.webp'),
      onlineMsg: {
        name: '',
        phone: '',
        email: '',
        content: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { max: 50, message: '长度不能超过50个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入您的咨询内容', trigger: 'blur' },
          { max: 500, message: '长度不能超过500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handler ({
      BMap,
      map
    }) {
      map.centerAndZoom(new BMap.Point(114.092453, 34.773547), 18) // 初始化地图，设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true) // 添加鼠标滚动，地图缩放组件
    },
    resetForm (formName) {
      Object.keys(this.onlineMsg).forEach(key => (this.onlineMsg[key] = ''))
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.onlineMsg.phone || this.onlineMsg.email) {
            if (this.onlineMsg.phone) {
              let regP = /^(1[3456789]\d{9}|0\d{2,3}-\d{7,8})$/
              if (!regP.test(this.onlineMsg.phone)) {
                this.$alert('联系电话格式错误，请填写正确的联系电话', '提示', {
                  confirmButtonText: '确定'
                })
                return false
              }
            }
            if (this.onlineMsg.email) {
              let regE = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/
              if (!regE.test(this.onlineMsg.email)) {
                this.$alert('邮箱格式错误，请填写正确的邮箱', '提示', {
                  confirmButtonText: '确定'
                })
                return false
              }
            }
            this.$axios.post('/medical/online', this.onlineMsg).then(resp => {
              if (resp.data) {
                this.$alert(resp.data.msg, '提示', {
                  confirmButtonText: '确定'
                })
              }
            }).catch(() => {
              this.$alert('系统错误，请稍后再试', '提示', {
                confirmButtonText: '确定'
              })
            })
          } else {
            this.$alert('提交失败，联系电话和邮箱至少需要填写一个', '提示', {
              confirmButtonText: '确定'
            })
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.main{
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 10px;
}
.map {
  width: 52%;
  height: 450px;
  margin-top: 20px;
  display: inline-block;
}
.sj-cpzx {
  width: 1800PX;
  height: 60px;
  margin-top: 20px;
  text-align: left;
  display: inline-block;
  color: rgba(49, 49, 49, 0.918);
  font-size: 26px;
}
.en-title {
  font-size: 25px;
  color: rgb(149, 158, 158);
}
.detail-title {
  font-size: 20px;
  color: rgba(49, 49, 49, 0.918);
}
.detail-main {
  font-size: 20px;
  font-weight: 600;
  color: rgb(50, 141, 211);
}
.sy-gywm {
  width: 1800PX;
  height: auto;
  margin-top: 10px;
  display: inline-block;
  text-align: left;
}
.comp-info {
    width: 48%;
    height: auto;
    float: left;
    margin-top: 60px;
    font-size: 20px;
}
.bt-comp-li {
  font-size: 16px;
  color: rgb(0, 0, 0);
}
.online-bg {
  width: 52%;
  height: auto;
  float: left;
  margin-top: 30px;
  margin-bottom: 50px;
}
.online-form {
  width: 45%;
  height: auto;
  margin-top: 30px;
  font-size: 16px;
  display: inline-block;
  margin-left: 40px;
}
/* 职位卡片 */
.job-card {
  background: white;
  border-radius: 10px;
  padding: 10px 30px 10px 30px;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
.job-title {
  color: #2c3e50;
  font-size: 1.3rem;
}
.job-det{
  font-size: 15px;
  color: #2c2c2c;
}
.job-info {
  gap: 2rem;
  color: #4d4d4f;
  margin-bottom: 1rem;
}
.job-description {
  font-size: 15px;
  color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue